import { render, staticRenderFns } from "./AttendanceDetails.vue?vue&type=template&id=6c8764c5&scoped=true&"
import script from "./AttendanceDetails.vue?vue&type=script&lang=js&"
export * from "./AttendanceDetails.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceDetails.vue?vue&type=style&index=0&id=6c8764c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8764c5",
  null
  
)

export default component.exports